import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './SelectField.less';

const optionListItemShape = PropTypes.shape({
    id: PropTypes.string,
    displayText: PropTypes.string.isRequired
});

const optionGroupShape = PropTypes.shape({
    groupName: PropTypes.string.isRequired,
    groupOptionList: PropTypes.arrayOf(optionListItemShape).isRequired
});

export class SelectField extends Component {

    static propTypes = {
        id: PropTypes.string.isRequired,
        label: PropTypes.string,
        placeholder: PropTypes.string,
        optionList: PropTypes.arrayOf(PropTypes.oneOfType([
            optionListItemShape,
            optionGroupShape
        ])).isRequired,
        required: PropTypes.bool,
        disabled: PropTypes.bool,
        hideLabel: PropTypes.bool,
        // Below props come from Field HOC
        input: PropTypes.object.isRequired,
        meta: PropTypes.object.isRequired
    };

    static defaultProps = {
        required: false,
        disabled: false
    };

    createSelectItems = (optionList) => {
        const items = [];

        for (const option of optionList) {
            const { id, displayText, groupName, groupOptionList } = option;
            if (groupName) {
                //process the group items with recursive call
                items.push(
                    //todo consider using dangerouslySetInnerHTML here for more flexibility
                    <optgroup label={groupName.replace(/%20/g, ' ')} key={groupName}>
                        { this.createSelectItems(groupOptionList) }
                    </optgroup>
                );
            } else {
                items.push(<option key={id} value={id}>{displayText}</option>);
            }
        }

        return items;
    };

    render() {
        const { input, id, label, placeholder, meta: { touched, active, error }, required, optionList, disabled, hideLabel } = this.props;
        const placeholderOption = placeholder ? <option value="" disabled>{placeholder}</option> : '';
        let selectClassName = (placeholder && input.value === '') ? ' placeholder-state' : '';
        const hasError = !!error && !!touched;
        const wrapClassName = `selectDropdown${active ? ' hovered' : ''}${hasError ? ' hasError' : ''}`;
        const labelElt = (label && id && input.value)
            ? <label htmlFor={id}>{label}</label>
            : '';


        const disableField = (disabled) ? 'disabled' : '';
        if (hideLabel) {
            selectClassName = selectClassName.concat(' labelless');
        }

        return (
            <div className="SelectField form-field">
                <div className={wrapClassName}>
                    <select
                        {...input}
                        id={id}
                        className={selectClassName}
                        required={required}
                        disabled={disableField}
                        data-errormsg={(error && error.msg) || ''}
                        data-haserror={hasError}
                        data-errorshowmsg={false} // we currently don't show error text for dropdowns
                    >
                        {placeholderOption}
                        {this.createSelectItems(optionList)}
                    </select>
                    {labelElt}
                </div>
            </div>
        );
    }
}

/**
 * Maps an object with key/value pairs mapping to the option value and option text of a select field.
 * ie. { key1: value1 } would map to <option value="key1">value1</option>
 * @param options
 */
export const mapOptionsToSelectField = (options) => {
    if (!options) {
        return [];
    }

    return Object.keys(options).map(key => {
        if (typeof options[key] === 'string') {
            return ({
                id: key,
                displayText: options[key]
            });
        } else {
            return ({
                groupName: key,
                groupOptionList: mapOptionsToSelectField(options[key])
            });
        }

    });
};

/**
 * Maps a simple array to the option value and option text of a select field.
 * ie. [1, 2] would map to <option value="1">1</option> <option value="2">2</option>
 * @param options
 */
export const mapListToSelectField = (list) => {
    if (!list) {
        return [];
    }

    return list.map(year => ({
        id: year.toString(),
        displayText: year.toString()
    }));
};

export default SelectField;
